import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import _ from 'lodash';
import {moment} from '../../../../../js/globals';
import { ClientLoggerService } from '../../../../services/client-logger.service';
import { MySynchEnumerationService } from '../../../../services/mysynch.enumeration.service';
import { MySynchConstantService } from '../../../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../../../services/performance-metrics.service';
import { PerformanceContextService } from '../../../../services/performance-context.service';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ParnellEnum,PerformanceContext } from '../../../../interfaces/mysynch.interfaces';

interface ActiveFarmRow {
    farmId: number;
    name: string;
    location: string;
    admin: string;
    status:number;
    adminEmail: string;
    adminCell: string; 
    originalStatus: number;
    lastEventDate: string | null;
    lastEventDateDisplay: string;
    lastEventDateHighlightColor: string;
}

@Component({
    standalone: false,
    selector: 'tm-active-farms-view',
    templateUrl: '../app/pages/tm-dashboard/views/tm-active-farms-view/tm-active-farms-view.view.html',
    styleUrls: ['../app/pages/tm-dashboard/views/tm-active-farms-view/tm-active-farms-view.style.css']
    })
export class TMActiveFarmsView implements OnInit , OnDestroy{
    
    private editFarmStateName:string = "FarmManagementMaint";
    private extraDisplayProperties:string[] = ['lastEventDateDisplay','lastEventDateHighlightColor'];
    private tmDashboardSiteConfig:any = {};
    private performanceContext: PerformanceContext | null = null;

    private farmStatuses: ParnellEnum[] = []; 
    private pendingValue:number = 0;
    private pendingText:string = "";

    isMobile:boolean = false;
    loading:boolean = true;
    _: any = _;

    farms: ActiveFarmRow[] = [];

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('CookieFactory') private cookies:any,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(MySynchConstantService) private mySynchConstSvc:MySynchConstantService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
        ){
            this.isMobile = this.deviceDetector.isMobile();
            this.farmStatuses =_.reject(_.values(this.mySynchEnumSvc.getMySynchEnumerationItems("PersonRoleStatus")), (i) => {
                                    return i.name === 'PENDING';
                                });
            this.pendingValue = _.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'value');
            this.pendingText  = _.get(this.mySynchEnumSvc.getMySynchEnumeration('FarmStatus','PENDING'),'text');
        }
    ngOnInit() {
        this.MSF.ready(() => {
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming("Page:TerritoryFarmDashboardActiveFarms:Render");
            var cfTMDashboardConfig = _.find(_.get(this.MSF,'lists.codeFile',[]),{codeType: "SITECONFIGS",code: "TMDASHBOARD"});
            
            if(!_.isUndefined(cfTMDashboardConfig)){
                var tmDashboardSiteConfig = _.cloneDeep(cfTMDashboardConfig);
                var detailsJson = this.MSF.safeGetParsedJson( _.get(tmDashboardSiteConfig,'detailsJson','{}'));
                if(!_.isEmpty(detailsJson)){
                    _.set(tmDashboardSiteConfig,'detailsJson',detailsJson[0]);
                    this.tmDashboardSiteConfig = tmDashboardSiteConfig;
                }
            }	
            this.refresh().then(() => {
                this.perfMetricSvc.markPageReady("Page:TerritoryFarmDashboardActiveFarms:Render", this.performanceContext);
            });
        });
    }

    ngOnDestroy() {
        this.performanceContext = null;
    }

    /**
     *  Function that gets the date format for the Connection Date Column
     * 	@param {string} dateString - date string of the CowEventsMeta.LastEventDate
     *  @returns formatted string version of CowEventsMeta.LastEventDate or empty string if dateString is null
     */
    private getFormattedConnectionDate(dateString:string|null):string{
        if(_.isNull(dateString)){
            return "";
        }
        
        
        var formattedDateString = moment(dateString).format(this.MSF.i18n.format.dateMedium);
        return formattedDateString;
    }
    /**
     * Function that gets the highlight color for the Connection Date Column based on the date and the highlight color cutoffs
     * @param {string} dateString - date string of the CowEventsMeta.LastEventDate
     * @returns (string) css highlight color for the Connection Date Column
     */
    private getHighlightColor(dateString:string|null):string{
        if(_.isNull(dateString)){
            return "";
        }
        
        var date = moment(dateString);
        var now = moment();
        var daysSinceLastEvent = now.diff(date,'days');
        var highlightColor = "none";
        var connectionDateHighlightCutoffs = _.get(this.tmDashboardSiteConfig,'detailsJson.connectionDateHighlightCutoffs',[]);
        
        _.forEach(connectionDateHighlightCutoffs,(cutoff) => {
            var minNumDaysOld = _.get(cutoff,'minNumDaysOld',0);
            var maxNumDaysOld = _.get(cutoff,'maxNumDaysOld',0);
            if(daysSinceLastEvent >= minNumDaysOld && daysSinceLastEvent < maxNumDaysOld){
                highlightColor = _.get(cutoff,'highlightColor',"none");
            }
        });
        return highlightColor;
    }

    private refresh() {
        return new Promise<void>((resolve, reject) => {
            this.loading = true;
            this.farms = [];
            this.perfMetricSvc.startTiming("Page:TerritoryFarmDashboardActiveFarmsPageData:Request");
            this.api.getFarmsForTerritoryDashboard(this.cookies.user.PersonId, this.performanceContext, (err:any, data:any) => {
                this.perfMetricSvc.endTiming("page","Page:TerritoryFarmDashboardActiveFarmsPageData:Request", this.performanceContext);
                this.perfMetricSvc.startTiming("Page:TerritoryFarmDashboardActiveFarms:Build");
                this.loading = false;
                if (err) {
                    this.log.error(this.MSF.notify.danger('unable to get farms: ' + err));
                    this.farms = [];

                    resolve();
                    this.perfMetricSvc.endTiming("page","Page:TerritoryFarmDashboardActiveFarms:Build", this.performanceContext);
                    return;
                }

               this.farms = _.map(data, (row: ActiveFarmRow) => {
                    row.originalStatus = row.status;

                    var lastEventDate = _.get(row,'lastEventDate',"");
                    // dateString isn't in UTC. So we want to remove the Z from the end of the string
                    if(_.includes(lastEventDate,'Z')){
                        lastEventDate = lastEventDate.slice(0,-1);
                    }

                    if(_.isEmpty(lastEventDate)){
                        // first assume that the farm is a dairy comp farm
                        var activeFarmNoDateText = _.get(this.tmDashboardSiteConfig,'detailsJson.activeDCFarmNoDateText',"");
                        var activeFarmNoDateHighlightColor = _.get(this.tmDashboardSiteConfig,'detailsJson.activeDCFarmNoDateHighlightColor',"");
                        // if the farm is not a dairy comp farm, then use the active farm no date text and highlight color for non dairy comp farms
                        if(!_.isEqual(_.get(row,'herdMgmtSoftware',""),_.get(this.mySynchConstSvc,'dairyCompHMSCode','DC305'))){
                            activeFarmNoDateText = _.get(this.tmDashboardSiteConfig,'detailsJson.activeNonDCFarmNoDateText',"");
                            activeFarmNoDateHighlightColor = _.get(this.tmDashboardSiteConfig,'detailsJson.activeNonDCFarmNoDateHighlightColor',"");
                        }
                        
                        _.set(row,'lastEventDateDisplay',activeFarmNoDateText);
                        _.set(row,'lastEventDateHighlightColor',activeFarmNoDateHighlightColor);
                    }else{
                        _.set(row,'lastEventDate',lastEventDate);
                        _.set(row,'lastEventDateDisplay',this.getFormattedConnectionDate(lastEventDate))
                        _.set(row,'lastEventDateHighlightColor',this.getHighlightColor(lastEventDate));
                    }



                    return row;
                });
                resolve();
                this.perfMetricSvc.endTiming("page","Page:TerritoryFarmDashboardActiveFarms:Build", this.performanceContext);
            });
        });
    }

    editFarm(farm: ActiveFarmRow){

        this.MSF.loadPage(this.editFarmStateName,{farmId: farm.farmId, tmDashSelectedTabName: "active-farms"});
    }
    
   
}